<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Threshold Configuration</h2>
    </div>
  </div>

  <div class="row g-3 mb-2">
    <div class="col-12 py-3">
      <!-- Search Filter Section -->
      <div class="ibox-content mb-1 px-3 py-2">
        <div class="form-group mb-1">
          <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">

            <!-- Risk ID -->
            <div class="form-group mb-lg-0 w-100 px-1">
              <label class="mb-0">Risk ID</label>
              <input type="text" class="form-control" v-model="searchField.riskID" />
            </div>

            <!-- Risk Name -->
            <div class="form-group mb-lg-0 w-100 px-1">
              <label class="mb-0">Risk Name</label>
              <input type="text" class="form-control" v-model="searchField.riskName" />
            </div>

            <!-- Search button -->
            <span class="col-sm-12 col-lg-2 save_btn my-1 my-lg-0 mx-lg-1 align-self-end" @click="searchThresholds">
              Search
            </span>

          </div>
        </div>
      </div>

      <div class="ibox-body">
        <!-- Header -->
        <div class="ibox-title style_2 d-flex justify-content-between">
          <h5 class="mt-1">Threshold List</h5>

          <div class="d-flex align-items-center">
            <!-- Filter icon -->
            <div class="position-relative cursor-pointer me-3" v-if="thresholdList.length"
              @click="showFilter = !showFilter">
              <img src="@/assets/img/filter.png" width="17" height="17" />
              <div class="tool-tip">Filter</div>
            </div>

            <!-- Create icon -->
            <div class="position-relative align-self-center">
              <img class="cursor-pointer" src="@/assets/img/create.png" width="17" height="17" alt="Create Threshold"
                @click="openCreateThreshold" />
              <div class="tool-tip">Create Threshold</div>
            </div>
          </div>
        </div>


        <div class="ibox-content">
          <div class="table-responsive custom-dark-table-wrapper table-scroll">
            <div class="d-flex justify-content-end px-0 mb-2" v-if="showFilter">
              <div class="col-3 px-0" v-on:clickout="dropdownOpen = false">
                <div class="table-multi-select-dropdown" @click.stop="dropdownOpen = !dropdownOpen">
                  <div class="selected-options">
                    <span>Select columns</span>
                  </div>
                  <div class="dropdown-arrow"></div>
                </div>

                <div v-if="dropdownOpen" class="table-dropdown-content" @click.stop>
                  <label v-for="(col, index) in getColumns" :key="index">
                    <input type="checkbox" v-model="selectedcolumnobj[col]" />
                    {{ col }}
                  </label>
                </div>
              </div>
            </div>

            <table class="table table-striped dark-table-head mb-0 fixed-column-table">
              <thead>
                <tr>
                  <th v-if="selectedcolumnobj['Risk ID']" class="sort_block" @click="sortSelected('riskID')">
                    <div class="d-flex justify-content-between">
                      Risk ID
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>

                  <th v-if="selectedcolumnobj['Risk Indicator']" class="sort_block" @click="sortSelected('riskName')">
                    <div class="d-flex justify-content-between">
                      Risk Indicator
                      <span>
                        <i class="fa fa-long-arrow-up"></i>
                        <i class="fa fa-long-arrow-down"></i>
                      </span>
                    </div>
                  </th>

                  <th v-if="selectedcolumnobj['Version']" class="sort_block" @click="sortSelected('version')">
                    <div class="d-flex justify-content-between">
                      Version

                    </div>
                  </th>

                  <th v-if="selectedcolumnobj['Unit']">Unit</th>
                  <th v-if="selectedcolumnobj['Thresholds']">Thresholds</th>
                  <th v-if="selectedcolumnobj['Risk Levels']">Risk Levels</th>
                  <th v-if="selectedcolumnobj['Critical Data Points']">Critical Data Points</th>


                  <th class="text-center">Edit</th>
                  <th class="text-center">Delete</th>
                </tr>
              </thead>


              <tbody>
                <tr v-for="item in thresholdList" :key="item.id">
                  <td v-if="selectedcolumnobj['Risk ID']">{{ item.riskID }}</td>
                  <td v-if="selectedcolumnobj['Risk Indicator']">{{ item.riskName }}</td>
                  <td v-if="selectedcolumnobj['Version']">{{ item.version }}</td>
                  <td v-if="selectedcolumnobj['Unit']">{{ item.unit }}</td>

                  <td v-if="selectedcolumnobj['Thresholds']" class="text-center">
                    <i class="fa fa-eye edit-delete" title="View Thresholds"
                      @click="openViewModal('thresholds', item)"></i>
                  </td>

                  <td v-if="selectedcolumnobj['Risk Levels']" class="text-center">
                    <i class="fa fa-eye edit-delete" title="View Risk Levels"
                      @click="openViewModal('riskLevels', item)"></i>
                  </td>

                  <td v-if="selectedcolumnobj['Critical Data Points']" class="text-center">
                    <i class="fa fa-eye edit-delete" title="View Critical Data Points"
                      @click="openViewModal('criticalDataPoints', item)"></i>
                  </td>


                  <td class="text-center">
                    <i class="fa fa-edit edit-delete" @click="editThreshold(item)"></i>
                  </td>

                  <td class="text-center">
                    <i class="fa fa-trash edit-delete" @click="deleteThreshold(item.id)"></i>
                  </td>
                </tr>

                <tr v-if="!thresholdList.length">
                  <td colspan="9" class="text-center">
                    No data available
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row mt-1 mx-0">
              <div class="col-lg-12 px-0">
                <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                  <div class="d-flex justify-content-lg-end px-0">
                    <v-pagination v-model="currentPage" :pages="totalPages" :range-size="1" active-color="#618bd7"
                      @update:modelValue="getThresholdList" />
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ThresholdAdd/edit modal start-->
  <ThresholdAddEditModal v-if="showThresholdModal" :isEditMode="isEditMode" :data="selectedThresholdData"
    @closeModal="closeThresholdModal" @saveThreshold="saveThreshold" />
  <!-- ThresholdAdd/edit modal end-->

  <!-- rbqm threshold view modal start -->
  <RbqmThresholdViewModal v-if="showViewModal" :type="viewType" :data="viewData" @closeModal="closeViewModal" />
  <!-- rbqm threshold view modal end -->

</template>

<script src="./RbqmThresholdList.js"></script>

<style scoped>
.edit-delete {
  cursor: pointer;
  color: #a13b7c;
}

.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}

.dark-table-head>thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}

.fixed-column-table {
  --last-col-width: 98px;
  --second-last-col-width: 80px;
  width: max-content;
  min-width: 100%;
}

.fixed-column-table th,
.fixed-column-table td {
  padding: 8px 12px;
  white-space: nowrap;
  background: #fff;
}

.fixed-column-table th:last-child,
.fixed-column-table td:last-child {
  width: var(--last-col-width);
  min-width: var(--last-col-width);
}

.fixed-column-table th:nth-last-child(2),
.fixed-column-table td:nth-last-child(2) {
  width: var(--second-last-col-width);
  min-width: var(--second-last-col-width);
}


.fixed-column-table thead th {
  position: sticky;
  top: 0;
  z-index: 0;
  background: #1a6aa2;
  color: #fff;
}

.fixed-column-table th:last-child,
.fixed-column-table td:last-child {
  position: sticky;
  right: 0;
  z-index: 0;
}

.fixed-column-table th:nth-last-child(2),
.fixed-column-table td:nth-last-child(2) {
  position: sticky;
  right: var(--last-col-width);
  z-index: 0;
}


.fixed-column-table thead th:last-child,
.fixed-column-table thead th:nth-last-child(2) {
  z-index: 1;
}

.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}

.data-grid-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
  padding: 0.25rem 0rem;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}

.thead-primary {
  background-color: #0095ff !important;
  color: #ffffff !important;
}

.table-hover tbody tr:hover {
  background-color: rgba(209, 236, 255, 0.05);
}

.table .editable-cell {
  cursor: pointer;
  position: relative;
  outline: none !important;
}

.table .editable-cell:hover {
  background-color: rgba(255, 255, 0, 0.1);
}

.table .editable-cell:focus {
  background-color: rgba(255, 255, 0, 0.171);
  outline: none !important;
  box-shadow: none !important;
}
</style>
